function defaultState() {
  return {
    isConnected: false,
    reconnectError: false,
    lastOrderEvent: null,
  };
}

const state = defaultState();

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
  SOCKET_ONOPEN(state) {
    console.log('[Vuex Socket] Mutation SOCKET_ONOPEN');
    state.isConnected = true;
    state.reconnectError = false;
  },
  SOCKET_ONCLOSE(state) {
    console.log('[Vuex Socket] Mutation SOCKET_ONCLOSE');
    state.isConnected = false;
  },
  SOCKET_ONERROR(state) {
    console.error('[Vuex Socket] Mutation SOCKET_ONERROR');
    state.reconnectError = true;
  },
  SOCKET_ORDER_EVENT(state, { type, data }) {
    console.log(`[Vuex Socket] Mutation SOCKET_ORDER_EVENT: ${type}`, data);
    state.lastOrderEvent = { type, data, timestamp: Date.now() };
  },
};

const actions = {
  connect({ commit }, { url, options }) {
    // This action is intercepted by the socket plugin to initiate connection
  },
  disconnect({ commit }) {
    // This action is intercepted by the socket plugin to close connection
  },
  sendMessage({ commit }, payload) {
    // This action can be intercepted by the plugin or called directly
  },
};

const getters = {
  isConnected: (state) => state.isConnected,
  lastOrderEvent: (state) => state.lastOrderEvent,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
